var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCreateTaskTimeRegistration, } from '@/shared/hooks/task/registration/useCreateTaskTimeRegistration';
import { useUpdateTaskStatus } from '@/shared/hooks/task/useUpdateTaskStatus';
import { useDataContext } from '@/shared/providers/DataProvider';
import { ModalType, useModalContext } from '@/shared/providers/ModalProvider';
import { useTaskTimerContext } from '@/shared/providers/TaskTimerProvider';
import ToastrService from '@/shared/services/ToastrService';
import { useEffect, useMemo, useState } from 'react';
import moment from 'moment';
import { DragDropContext, Draggable, Droppable, } from '@hello-pangea/dnd';
import { useIntl } from 'react-intl';
import taskMessages from '@/modules/tasks/taskMessages';
import authService, { functionalities, privileges } from '@/shared/services/AuthService';
import appMessages from '@/shared/messages/appMessages';
import { Method, TaskStatus, TaskType } from './constants';
import { getContainerListStyle, getItemStyle, getKanbanBoardColumns, getListStyle, getSubTaskByStatusMap, } from './helper';
import SubTaskComponent from './task/SubTask';
// eslint-disable-next-line react/prop-types
var KanbanBoard = function (_a) {
    var task = _a.task, shareItem = _a.shareItem;
    var intl = useIntl();
    var subTaskByStatusMap = getSubTaskByStatusMap(task.children);
    var initialColumns = getKanbanBoardColumns(subTaskByStatusMap);
    var _b = useState(initialColumns), columns = _b[0], setColumns = _b[1];
    var updateTaskStatus = useUpdateTaskStatus().updateTaskStatus;
    var createTaskTimeRegistration = useCreateTaskTimeRegistration().createTaskTimeRegistration;
    var setShowModalInfo = useModalContext().setShowModalInfo;
    var _c = useDataContext(), defaultCompany = _c.defaultCompany, currentUserId = _c.currentUserId;
    var processTimeRegistrationResult = useTaskTimerContext().processTimeRegistrationResult;
    useEffect(function () {
        var updatedColumns = getKanbanBoardColumns(getSubTaskByStatusMap(task.children));
        setColumns(updatedColumns);
    }, [task.children]);
    var canCreateTask = useMemo(function () {
        return authService.hasPermission({
            functionality: functionalities.PlannedTask,
            privilege: privileges.Create,
        });
    }, []);
    var canUpdateTask = useMemo(function () {
        return authService.hasPermission({
            functionality: functionalities.PlannedTask,
            privilege: privileges.Update,
        });
    }, []);
    var onCreateSubTask = function () {
        var newSubTask = {
            parentId: task.id,
            parent: task,
            name: intl.formatMessage(taskMessages.NewTask),
            deadline: moment
                .utc(task.deadline)
                .utcOffset(0)
                .toISOString(),
            status: 0,
            invoiceStreamId: task.invoiceStreamId,
            relationId: task.relationId,
            relation: task.relation,
            userId: currentUserId,
            taskLevel: 1, // This is a subtask
        };
        setShowModalInfo({ modalType: ModalType.TaskDetail, task: newSubTask });
    };
    var updateStatus = function (subTaskToUpdate, status) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, updateTaskStatus({
                        id: subTaskToUpdate.id,
                        status: status,
                        isBlocked: subTaskToUpdate.isBlocked,
                        inapplicable: false,
                        rejected: false, // when dragging the task we'll always clear this status
                    })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var onTaskMailModalClosed = function (subTaskToUpdate, status) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(status === TaskStatus.InProgress)) return [3 /*break*/, 2];
                    return [4 /*yield*/, updateTaskStatus({
                            id: subTaskToUpdate.id,
                            status: TaskStatus.Todo,
                            isBlocked: subTaskToUpdate.isBlocked,
                            inapplicable: subTaskToUpdate.inapplicable,
                            rejected: subTaskToUpdate.rejected,
                        })];
                case 1:
                    _a.sent();
                    ToastrService.info(intl.formatMessage(appMessages.msgTaskEmailCancelled));
                    setColumns(columns);
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var onTaskMailModalSaved = function (subTaskToUpdate) { return __awaiter(void 0, void 0, void 0, function () {
        var taskTimeRegistration, timeRegistrationResult, updatedColumns;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (subTaskToUpdate.type !== TaskType.Mail && subTaskToUpdate.type !== TaskType.AutomaticMail)
                        return [2 /*return*/];
                    return [4 /*yield*/, updateTaskStatus({
                            id: subTaskToUpdate.id,
                            status: TaskStatus.Done,
                            isBlocked: subTaskToUpdate.isBlocked,
                            inapplicable: subTaskToUpdate.inapplicable,
                            rejected: subTaskToUpdate.rejected,
                        })];
                case 1:
                    _a.sent();
                    if (!(defaultCompany.taskTimeRegistrationMethod === Method.AutomaticRegistration)) return [3 /*break*/, 6];
                    if (!(subTaskToUpdate.defaultDuration && subTaskToUpdate.defaultDuration > 0)) return [3 /*break*/, 4];
                    taskTimeRegistration = {
                        plannedTaskId: subTaskToUpdate.id,
                        plannedTaskTemplateId: subTaskToUpdate.templateId,
                        plannedTaskName: subTaskToUpdate.name,
                        invoiceStreamId: subTaskToUpdate.invoiceStreamId,
                        relationId: subTaskToUpdate.relationId,
                        resourceId: subTaskToUpdate.resourceId,
                        durationMinutes: subTaskToUpdate.defaultDuration,
                        mainPlannedTaskId: task.id,
                        mainTaskTemplateId: task.templateId,
                        mainPlannedTaskName: task.name,
                    };
                    return [4 /*yield*/, createTaskTimeRegistration(taskTimeRegistration)];
                case 2:
                    timeRegistrationResult = _a.sent();
                    return [4 /*yield*/, processTimeRegistrationResult(timeRegistrationResult)];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 4:
                    ToastrService.info(intl.formatMessage(appMessages.msgNoRegistrationMadeDefaultTimeZero));
                    _a.label = 5;
                case 5: return [3 /*break*/, 7];
                case 6:
                    if (defaultCompany.taskTimeRegistrationMethod === Method.OpenFormOnDone) {
                        subTaskToUpdate.relation = task.relation;
                        subTaskToUpdate.mainTaskId = task.id;
                        subTaskToUpdate.mainTemplateId = task.templateId;
                        subTaskToUpdate.assignmentTemplateId = task.assignmentTemplateId;
                        setShowModalInfo({ modalType: ModalType.TimeRegistration, task: subTaskToUpdate });
                    }
                    _a.label = 7;
                case 7:
                    updatedColumns = getKanbanBoardColumns(getSubTaskByStatusMap(task.children));
                    setColumns(updatedColumns);
                    return [2 /*return*/];
            }
        });
    }); };
    var onOpenTaskDetails = function (taskToOpen) {
        setShowModalInfo({
            modalType: ModalType.TaskDetail,
            task: taskToOpen,
            onTaskMailModalSaved: function () { return onTaskMailModalSaved(taskToOpen); },
        });
    };
    var onTaskStateChange = function (subTaskToUpdate, status, prevStatus) { return __awaiter(void 0, void 0, void 0, function () {
        var updateBoard, taskType, taskTimeRegistration, timeRegistrationResult;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    updateBoard = false;
                    if (status === prevStatus)
                        return [2 /*return*/];
                    taskType = subTaskToUpdate.type;
                    subTaskToUpdate.isBlocked = false; // when moving a task we'll always unblock it
                    if (!((taskType === TaskType.Mail || taskType === TaskType.AutomaticMail) &&
                        status === TaskStatus.InProgress)) return [3 /*break*/, 1];
                    subTaskToUpdate.relation = task.relation;
                    setShowModalInfo({
                        modalType: ModalType.TaskMail,
                        task: subTaskToUpdate,
                        onSave: function () { return onTaskMailModalSaved(subTaskToUpdate); },
                        onClose: function () { return onTaskMailModalClosed(subTaskToUpdate, status); },
                    });
                    updateBoard = true;
                    return [3 /*break*/, 5];
                case 1:
                    if (!((taskType === TaskType.Mail || taskType === TaskType.AutomaticMail) &&
                        status === TaskStatus.Done)) return [3 /*break*/, 3];
                    return [4 /*yield*/, updateStatus(subTaskToUpdate, status)];
                case 2:
                    _a.sent();
                    updateBoard = true;
                    ToastrService.info(intl.formatMessage(appMessages.taskMgmtSendMailContent), intl.formatMessage(appMessages.taskMgmtSendMailTitle), function () {
                        subTaskToUpdate.relation = task.relation;
                        setShowModalInfo({
                            modalType: ModalType.TaskMail,
                            task: subTaskToUpdate,
                            onSave: function () { return onTaskMailModalSaved(subTaskToUpdate); },
                            onClose: function () { return onTaskMailModalClosed(subTaskToUpdate, status); },
                        });
                    });
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, updateStatus(subTaskToUpdate, status)];
                case 4:
                    _a.sent();
                    updateBoard = true;
                    if (status === TaskStatus.Done &&
                        defaultCompany.taskTimeRegistrationMethod === Method.OpenFormOnDone &&
                        taskType !== TaskType.Condition) {
                        // Move to 'Done' should open registration form
                        subTaskToUpdate.relation = task.relation;
                        subTaskToUpdate.mainTaskId = task.id;
                        subTaskToUpdate.mainTemplateId = task.templateId;
                        subTaskToUpdate.assignmentTemplateId = task.assignmentTemplateId;
                        setShowModalInfo({ modalType: ModalType.TimeRegistration, task: subTaskToUpdate });
                    }
                    _a.label = 5;
                case 5:
                    if (!(status === TaskStatus.Done &&
                        (taskType === TaskType.DefaultTime ||
                            taskType === TaskType.Mail ||
                            taskType === TaskType.AutomaticMail) &&
                        defaultCompany.taskTimeRegistrationMethod === Method.AutomaticRegistration)) return [3 /*break*/, 9];
                    if (!(subTaskToUpdate.defaultDuration && subTaskToUpdate.defaultDuration > 0)) return [3 /*break*/, 8];
                    taskTimeRegistration = {
                        plannedTaskId: subTaskToUpdate.id,
                        plannedTaskTemplateId: subTaskToUpdate.templateId,
                        plannedTaskName: subTaskToUpdate.name,
                        invoiceStreamId: subTaskToUpdate.invoiceStreamId,
                        relationId: subTaskToUpdate.relationId,
                        resourceId: subTaskToUpdate.resourceId,
                        durationMinutes: subTaskToUpdate.defaultDuration,
                        mainPlannedTaskId: task.id,
                        mainTaskTemplateId: task.templateId,
                        mainPlannedTaskName: task.name,
                    };
                    return [4 /*yield*/, createTaskTimeRegistration(taskTimeRegistration)];
                case 6:
                    timeRegistrationResult = _a.sent();
                    return [4 /*yield*/, processTimeRegistrationResult(timeRegistrationResult)];
                case 7:
                    _a.sent();
                    return [3 /*break*/, 9];
                case 8:
                    ToastrService.info(intl.formatMessage(appMessages.msgNoRegistrationMadeDefaultTimeZero));
                    _a.label = 9;
                case 9: return [2 /*return*/, updateBoard];
            }
        });
    }); };
    var onDragEnd = function (result) { return __awaiter(void 0, void 0, void 0, function () {
        var source, destination, startColumn, finishColumn, startItemIds, movingItemId, subTaskToUpdate, newStartColumn, finishItemIds, newFinishColumn, newColumns, startIndex, finishIndex, prevStatus, status, updateBoard;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // dropped nowhere
                    if (!result.destination) {
                        return [2 /*return*/];
                    }
                    source = result.source;
                    destination = result.destination;
                    startColumn = columns.find(function (f) { return f.id === source.droppableId; });
                    finishColumn = columns.find(function (f) { return f.id === destination.droppableId; });
                    // did not move anywhere - can bail early
                    if (source.droppableId === destination.droppableId && source.index === destination.index) {
                        return [2 /*return*/];
                    }
                    // same columns
                    if (startColumn === finishColumn) {
                        return [2 /*return*/];
                    }
                    startItemIds = Array.from(startColumn.itemIds);
                    movingItemId = startColumn.itemIds[source.index];
                    subTaskToUpdate = task.children.find(function (f) { return f.id === movingItemId; });
                    if (!subTaskToUpdate)
                        return [2 /*return*/];
                    startItemIds.splice(source.index, 1);
                    newStartColumn = __assign(__assign({}, startColumn), { itemIds: startItemIds });
                    finishItemIds = Array.from(finishColumn.itemIds);
                    finishItemIds.splice(destination.index, 0, movingItemId);
                    newFinishColumn = __assign(__assign({}, finishColumn), { itemIds: finishItemIds });
                    newColumns = columns.slice();
                    startIndex = columns.findIndex(function (f) { return f.id === source.droppableId; });
                    newColumns[startIndex] = newStartColumn;
                    finishIndex = columns.findIndex(function (f) { return f.id === destination.droppableId; });
                    newColumns[finishIndex] = newFinishColumn;
                    prevStatus = Number(source.droppableId);
                    status = Number(destination.droppableId);
                    if (subTaskToUpdate.type === TaskType.Condition && status === TaskStatus.InProgress) {
                        ToastrService.info(intl.formatMessage(appMessages.msgTaskOfTypeConditionCannotBeSetInProgress));
                        newColumns[startIndex] = startColumn;
                        newColumns[finishIndex] = finishColumn;
                        setColumns(newColumns);
                        return [2 /*return*/];
                    }
                    setColumns(newColumns);
                    return [4 /*yield*/, onTaskStateChange(subTaskToUpdate, status, prevStatus)];
                case 1:
                    updateBoard = _a.sent();
                    if (!updateBoard) {
                        setColumns(newColumns);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var reloadColumns = function () {
        var updatedColumns = getKanbanBoardColumns(getSubTaskByStatusMap(task.children));
        setColumns(updatedColumns);
    };
    var getElement = function (provided, snapshot, subTask) { return (_jsx("div", __assign({ ref: provided.innerRef }, provided.draggableProps, provided.dragHandleProps, { style: getItemStyle(snapshot.isDragging, provided.draggableProps.style) }, { children: _jsx("div", { children: _jsx("div", __assign({ className: "dskb-content-box" }, { children: _jsx(SubTaskComponent, { isDragging: snapshot.isDragging, task: task, subTask: subTask, shareItem: shareItem, openTaskDetails: onOpenTaskDetails, reloadColumns: reloadColumns }, "".concat(task.id).concat(subTask.id)) })) }) }))); };
    var getItemList = function (column, dropProvided, dropSnapshot) { return (_jsxs("div", __assign({ ref: dropProvided.innerRef }, dropProvided.droppableProps, { style: getListStyle(dropSnapshot.isDraggingOver) }, { children: [column.itemIds.map(function (itemId, index) {
                var item = task.children.find(function (f) { return f.id === itemId; });
                if (!item)
                    return;
                return (_jsx(Draggable, __assign({ draggableId: item.id, index: index, isDragDisabled: !canUpdateTask }, { children: function (provided, snapshot) { return getElement(provided, snapshot, item); } }), item.id));
            }), _jsx("div", __assign({ style: { width: '25vw' } }, { children: dropProvided.placeholder })), column.id === '0' && canCreateTask && (_jsx("div", { children: _jsx("button", __assign({ type: "button", className: "btn btn-default btn-xsm", style: { marginTop: column.itemIds.length > 0 ? '10px' : '0px' }, onClick: onCreateSubTask, title: intl.formatMessage(taskMessages.NewTask) }, { children: _jsx("i", { className: "fa fa-plus" }) })) }))] }))); };
    var getColumn = function (column) { return (_jsx("td", __assign({ className: "dskb-cell dskb-items-container" }, { children: _jsx("div", __assign({ className: "kanban-item-mjr", style: getContainerListStyle() }, { children: _jsx(Droppable, __assign({ droppableId: column.id, type: "ITEM", isDropDisabled: !canUpdateTask }, { children: function (dropProvided, dropSnapshot) {
                    return getItemList(column, dropProvided, dropSnapshot);
                } }), column.id) })) }), column.id)); };
    return (_jsx(DragDropContext, __assign({ onDragEnd: onDragEnd }, { children: columns.map(function (column) { return getColumn(column); }) })));
};
export default KanbanBoard;
